export interface Person_Interface {
  id:number,
  fname:String,
  lname:String,
  shomareh_bimeh:String,
  mahal_tavalod:number,
  codeMeli:number,
  name_Hamsar:String,
  name_Pedar:String,
  shoghleh_Pedar:String,
  codeMeli_Hamsar:number,
  shomareh_Shenasnameh:number,
  shomareh_hamrah_Hamsar:String,
  shomareh_Shenasnameh_Seri:String,
  shomareh_Hamreh:String,
  email:String,
  tahsilat_Hamsar:number,
  vaziat_Nazam_Vazifeh:number,
  vaziat_Nazam_Vazifeh_Dsc:String,
  vaziat_Tahol:number,
  tarikh_Tavalod_Hamsar:String,
  tarikh_Tavalod:String,
  maskan:number,
  address_Manzel:String,
  shoghleh_Hamsar:String,
  tel:String,
  codeposti:String,
  sign_image:String,

  sex:boolean,
  vaziat_startDate:String,
  vaziat_endDate:String,
  tedadFarzandan:Number,
  sabegh:Number,


  codemeli_Image1:String,
  codemeli_Image2:String,
  shenasNameh_Image1:String,
  shenasNameh_Image2:String,
  form_reserve_mosahebeh_Image:String,
  shenasNameh_Image3:String,
  kartPayan_Khadamt_Image:String,
  form_soe_Pishineh_Image:String,
  ax_Personeli_Image:String,
  ax_Personeli_Image2:String,
  tarikh_Eshtekhdam:String,
  almat_Ekhtesari:String,
  field_activity_id:number,
  semat_id:number,
}

export function Empty_Person_Interface(){
  return{
    id:0,
    fname:'',
    lname:'',
    shomareh_bimeh:'',
    mahal_tavalod:0,
    codeMeli:0,
    name_Hamsar:'',
    name_Pedar:'',
    shoghleh_Pedar:'',
    codeMeli_Hamsar:0,
    shomareh_Shenasnameh:0,
    shomareh_hamrah_Hamsar:'-1',
    shomareh_Shenasnameh_Seri:'',
    shomareh_Hamreh:'-1',
    email:'-1',
    tahsilat_Hamsar:0,
    vaziat_Nazam_Vazifeh:0,
    vaziat_Nazam_Vazifeh_Dsc:'',
    vaziat_Tahol:0,
    tarikh_Tavalod_Hamsar:'',
    tarikh_Tavalod:'',
    maskan:0,
    address_Manzel:'-1',
    shoghleh_Hamsar:'',
    tel:'-1',
    codeposti:'-1',

    sex:false,
    vaziat_startDate:'',
    vaziat_endDate:'',
    tedadFarzandan:0,


    codemeli_Image1:'',
    codemeli_Image2:'',
    shenasNameh_Image1:'',
    shenasNameh_Image2:'',
    form_reserve_mosahebeh_Image:'',
    shenasNameh_Image3:'',
    kartPayan_Khadamt_Image:'',
    form_soe_Pishineh_Image:'',
    ax_Personeli_Image:'',
    ax_Personeli_Image2:'',
    sign_image:'',
    tarikh_Eshtekhdam:'',
    almat_Ekhtesari:'',
    field_activity_id:0,
    semat_id:0,
    sabegh:0,
  }
}
